import { render, staticRenderFns } from "./DataSync.vue?vue&type=template&id=ba2544a6&"
import script from "./DataSync.vue?vue&type=script&lang=js&"
export * from "./DataSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports